import Vue from 'vue'


import ValidationErrors from '@/shared/components/ValidationErrors'
import CustomFormItem from '@/shared/components/CustomFormItem'

// ElementUI
import '@/shared/utils/element'

// Axios
import '@/shared/utils/axios'

Vue.component('errors', ValidationErrors)
Vue.component('custom-form-item', CustomFormItem)



// WEBPACK FOOTER //
// ./resources/js/auth/plugins.js